// extracted by mini-css-extract-plugin
export default {"FAQAccordionCard":"FAQAccordionCard_FAQAccordionCard__AOsqK","attribution":"FAQAccordionCard_attribution__qzeBo"};